/*
 * @Author: your name
 * @Date: 2022-04-24 14:27:06
 * @LastEditTime: 2022-10-14 14:21:20
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /streamline_detail/src/store/index.ts
 */
import { StateType } from '@/model/stateInfo'
import VueCompositionAPI, { reactive } from '@vue/composition-api'
import Vue from 'vue'
import { Actions } from './actions'
import { Mutations } from './mutations'
Vue.use(VueCompositionAPI)

const state: StateType = reactive({
  initCollected: false,
  bubbleInfo: {},
  abMap: {}, // ab实验分组
  collectionCount: 0, // 收藏数量
  testGroup: '', // 分组信息
  addressInformation: {}, // 省市区信息
  btnInfo: {}, // 以旧换新底部按钮数据
  collected: false,
  couponsNewUser: [],
  coupons: [],
  couponsCharged: [],
  isShowCouponPop: false,
  newUserCouponPendant: null,
  showCouponsNewUser: null,
  actInfoVo: null,
  showEvaluate: false,
  infoId: '',
  orderId: '',
  metric: '',
  quickStart: '',
  qcCode: '',
  packageId: '',
  cateId: 101,
  brandUpgrade: true,
  addressId: '', // $ 品牌升级新增用户选择地址 地址id
  addressJson: {}, // $ 品牌升级新增用户选择地址 地址信息
  saleCombineIds: '', // $ 搭售商品
  fromInstallment: '',
  pageState: 0,
  whetherShowPosteriorQcStyle: 0, // 是否命中后验流程
  version: '',
  t: '',
  ip: '',
  proId: '',
  cityId: '',
  disId: '',
  uid: '',
  initFrom: '',
  cateFirstId: '',
  showQuestionnaireUrl: 0,
  initCartStatus: false, // 购物车初始化状态
  cartStatus: false, // 购物车状态
  cartInfoNum: 0, // 购物车数量
  upgradeStyle: 0, // 升级类型
  accessoryList: [],
  evalListData: {}, // 收官项目新增字段
  zcShowListData: {}, // 收官项目新增字段
  rating: {}, // 评分
  satisfactionRate: '', // 好评率
  orderEvaluateNum: 0, //评价数
  brandId: '',
  infoType: 1000,
  joinCalRealPriceRedPlans: null, // 自动领券标识
  isLogin: false // 是否登录
})

const setState = (val: StateType) => {
  for (const key in val) {
    if (Object.prototype.hasOwnProperty.call(state, key)) {
      state[key] = val[key]
    }
  }
}

export { Mutations, Actions, setState, state }
